import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Button, Grid, Image, Modal, Select, TextField, Typography } from '@iho-design-system/Loader';

/*
    - icon
*/
import SearchSVG from '../../../assets/images/icons/search.svg';

/*
    - api
*/
import post from '../../../api/post';
import getApi from '../../../api/get';
const Toolbar = ({ props, alertProps, multiSearchProps, reloadUserProps }) => {

    /*
       - default data   
    */
    const [subCompanies, setSubCompanies] = React.useState('empty');
    const [multiSearchKey, setMultiSearchKey] = React.useState('');
    const [addAgentParameters, setAddAgentParameters] = React.useState({
        organizationId: {
            value: '',
            color: 'dark'
        },
        firstName: {
            value: '',
            color: 'dark'
        },
        lastName: {
            value: '',
            color: 'dark'
        },
        mobileNumber: {
            value: '',
            color: 'dark'
        },
        email: {
            value: '',
            color: 'dark'
        }
    });

    React.useEffect(() => {
        if (props.subCompanies.status === 200 && props.subCompanies.data.length > 0) {
            setSubCompanies(props.subCompanies.data);
        } else {
            setSubCompanies('empty');
        }
    }, [props]);

    /*
        - addAgentHandler
    */
    const addAgentHandler = (key, value) => {
        if (key === 'organizationId' && value === '') {
            setAddAgentParameters({
                ...addAgentParameters,
                organizationId: {
                    value: value,
                    color: 'danger'
                }
            });
        } else if (key === 'organizationId') {
            setAddAgentParameters({
                ...addAgentParameters,
                organizationId: {
                    value: value,
                    color: 'dark'
                }
            });
        }
        if (key === 'firstName' && (value === '' || !/^[آ-ی ]+$/.test(value))) {
            setAddAgentParameters({
                ...addAgentParameters,
                firstName: {
                    value: value,
                    color: 'danger'
                }
            });
        } else if (key === 'firstName') {
            setAddAgentParameters({
                ...addAgentParameters,
                firstName: {
                    value: value,
                    color: 'dark'
                }
            });
        }
        if (key === 'lastName' && (value === '' || !/^[آ-ی ]+$/.test(value))) {
            setAddAgentParameters({
                ...addAgentParameters,
                lastName: {
                    value: value,
                    color: 'danger'
                }
            });
        } else if (key === 'lastName') {
            setAddAgentParameters({
                ...addAgentParameters,
                lastName: {
                    value: value,
                    color: 'dark'
                }
            });
        }
        if (key === 'mobileNumber') {
            if ((value.length === 0 || value.length === 11) && /^[0-9,۰-۹]+$/.test(value)) {
                setAddAgentParameters({
                    ...addAgentParameters,
                    mobileNumber: {
                        value: value,
                        color: 'dark'
                    }
                });
            } else {
                setAddAgentParameters({
                    ...addAgentParameters,
                    mobileNumber: {
                        value: value,
                        color: 'danger'
                    }
                });
            }
        }
        if (key === 'email') {
            if (value.length !== 0 && /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)) {
                setAddAgentParameters({
                    ...addAgentParameters,
                    email: {
                        value: value,
                        color: 'dark'
                    }
                });
            } else {
                setAddAgentParameters({
                    ...addAgentParameters,
                    email: {
                        value: value,
                        color: 'danger'
                    }
                });
            }
        }
    }

    /*
        - addAgent
    */
    const addAgent = async () => {
        let body = {};
        let isValid = 1;
        if (addAgentParameters.organizationId.value === '') {
            setAddAgentParameters({
                ...addAgentParameters,
                organizationId: {
                    value: addAgentParameters.organizationId.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (addAgentParameters.firstName.value === '' || !/^[آ-ی ]+$/.test(addAgentParameters.firstName.value)) {
            setAddAgentParameters({
                ...addAgentParameters,
                firstName: {
                    value: addAgentParameters.firstName.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (addAgentParameters.lastName.value === '' || !/^[آ-ی ]+$/.test(addAgentParameters.lastName.value)) {
            setAddAgentParameters({
                ...addAgentParameters,
                lastName: {
                    value: addAgentParameters.lastName.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (addAgentParameters.mobileNumber.value.length !== 11 || !/^[\u06F0-\u06F90-9]+$/.test(addAgentParameters.mobileNumber.value)) {
            setAddAgentParameters({
                ...addAgentParameters,
                mobileNumber: {
                    value: addAgentParameters.mobileNumber.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (addAgentParameters.email.value.length === 0 || !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(addAgentParameters.email.value)) {
            setAddAgentParameters({
                ...addAgentParameters,
                email: {
                    value: addAgentParameters.email.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (isValid === 1) {
            body.OrgnizationId = addAgentParameters.organizationId.value;
            body.FirstName = addAgentParameters.firstName.value;
            body.LastName = addAgentParameters.lastName.value;
            body.email = addAgentParameters.email.value;
            body.MobileNumber = addAgentParameters.mobileNumber.value;
            let parameters = {
                ctrl: 'UserAgents',
                method: 'RegisterAgent',
                query: '',
                body: body
            };
            let result = await post(parameters);
            if (result.status === 200) {
                alertProps(['success', 'با موفقیت انجام شد']);
                reloadUserProps(Math.floor(Math.random() * 100));
            } else {
                alertProps(['danger', result.data.Message]);
            }
            closeModal('addMemberModal');
            setAddAgentParameters({
                organizationId: {
                    value: '',
                    color: 'dark'
                },
                firstName: {
                    value: '',
                    color: 'dark'
                },
                lastName: {
                    value: '',
                    color: 'dark'
                },
                mobileNumber: {
                    value: '',
                    color: 'dark'
                },
                email: {
                    value: '',
                    color: 'dark'
                }
            });
        }
    }

    /*
        - nationalCodeSearch
    */
    const multiSearch = () => {
        multiSearchProps(multiSearchKey);
    }

    /*
        - modal
    */
        const openModal = async (modal) => {
            document.querySelector(`.${modal}`).classList.remove('d-none');
            if (modal === 'addMemberModal' && subCompanies === 'empty') {
                const result = await getApi({ ctrl: 'UserAgents', method: 'GetSubCompanies', query: '' });
                if (result.status === 200 && result.data.length > 0) {
                    setSubCompanies(result.data);
                } else {
                    setSubCompanies('empty');
                }
            }
        };

    const closeModal = (modal) => {
        document.querySelector(`.${modal}`).classList.add('d-none');
    }

    /*
        - scale
    */
    const screenWidth = window.innerWidth;
    let scale = '';
    if (screenWidth > 1400) {
        scale = 'xx-large';
    } else if (screenWidth <= 1400 && screenWidth > 1200) {
        scale = 'x-large';
    } else if (screenWidth <= 1200 && screenWidth > 992) {
        scale = 'large'
    } else if (screenWidth <= 992 && screenWidth > 768) {
        scale = 'medium'
    } else if (screenWidth <= 768 && screenWidth > 576) {
        scale = 'small'
    } else if (screenWidth <= 576) {
        scale = 'x-small'
    }

    return (
        <React.Fragment>
            <Grid>
                <Grid.Wrapper>
                    <Grid.Item
                        size='col-12'>
                        <Typography
                            component='h4'
                            ms={{
                                fontWeight: 'normal !important'
                            }}>
                            مدیریت نمایندگان
                        </Typography>
                        <Typography
                            className={`d-block`}
                            component='p'
                            ms={{
                                color: '#6F6F7E'
                            }}>
                            می توانید لیست نمایندگان سازمان خود را در زیر اضافه کنید، تااز خدمات ایران هتل آنلاین بهره‌مند شوند.
                        </Typography>
                    </Grid.Item>
                    <Grid.Item
                        className={`position-relative`}
                        size='col-8 md-4'>
                        <TextField
                            onChange={(value) => setMultiSearchKey(value)}
                            placeholder='جستجو بر اساس نام و شماره موبایل'
                            value={multiSearchKey} />
                        <Button
                            onClick={multiSearch}
                            variant='light'
                            color='primary'
                            size='sm'
                            ms={{
                                position: 'absolute',
                                top: '12px',
                                left: '12px',
                            }}>
                            <Image
                                src={SearchSVG} />
                        </Button>
                    </Grid.Item>
                    <Grid.Item
                        className={`text-left`}
                        size='col-4 md-8'>
                        {(scale === 'xx-large' || scale === 'x-large' || scale === 'large' || scale === 'medium' || scale === 'small') &&
                            <Button
                                onClick={() => openModal('addMemberModal')}
                                color='primary'
                                ms={{
                                    '@media(max-width:576px)': {
                                        width: '100% !important'
                                    }
                                }}>
                                افزودن نماینده جدید
                            </Button>
                        }
                        {(scale === 'x-small' || scale === 'x-small') &&
                            <Button
                                onClick={() => openModal('addMemberModal')}
                                color='primary'
                                ms={{
                                    '@media(max-width:576px)': {
                                        width: '100% !important'
                                    }
                                }}>
                                عضو جدید
                            </Button>
                        }
                    </Grid.Item>
                </Grid.Wrapper>
            </Grid>
            <Modal
                className={`addMemberModal`}>

                <Modal.Wrapper
                    size='xs'
                    ms={{
                        '@media(max-width:576px)': {
                            width: 'calc(100% - 12px) !important'
                        }
                    }}>
                    <Modal.Header
                        className={`border-solid-bottom border-light`}>
                        افزودن نماینده جدید
                        <Box />
                    </Modal.Header>
                    <Box
                        className={`my-md mt-0`} />
                    <Typography
                        className={`px-lg`}>
                        اطلاعات نماینده خود را وارد نمایید.
                    </Typography>
                    <Box
                        className={`p-sm`}
                        component='form'>
                        <Grid>
                            <Grid.Wrapper>
                                {subCompanies !== 'empty' &&
                                    <Grid.Item
                                        size='col-12'>
                                        <Select
                                            onChange={(value) => addAgentHandler('organizationId', value)}
                                            label='نام شرکت'
                                            color={addAgentParameters.organizationId.color}
                                            value={addAgentParameters.organizationId.value}>
                                            {subCompanies.map((obj, index) => {
                                                return (
                                                    <Select.Item
                                                        key={index}
                                                        value={obj.Id}>
                                                        {obj.FullName}
                                                    </Select.Item>
                                                );
                                            })}
                                        </Select>
                                    </Grid.Item>
                                }
                                {subCompanies === 'empty' &&
                                <Grid.Item
                                size='col-12'>
                                <Select
                                    label='نام شرکت'
                                    color={addAgentParameters.organizationId.color}
                                    disabled
                                    >
                                </Select>
                            </Grid.Item>
                                }
                                <Grid.Item
                                    size='col-12 md-6'>
                                    <TextField
                                        onChange={(value) => addAgentHandler('firstName', value)}
                                        label='نام'
                                        color={addAgentParameters.firstName.color}
                                        value={addAgentParameters.firstName.value} />
                                </Grid.Item>
                                <Grid.Item
                                    size='col-12 md-6'>
                                    <TextField
                                        onChange={(value) => addAgentHandler('lastName', value)}
                                        label='نام خانوادگی'
                                        color={addAgentParameters.lastName.color}
                                        value={addAgentParameters.lastName.value} />
                                </Grid.Item>
                                <Grid.Item
                                    size='col-12 md-6'>
                                    <TextField
                                        onChange={(value) => addAgentHandler('mobileNumber', value)}
                                        label='شماره همراه'
                                        placeholder='091xxxxxxxxx'
                                        color={addAgentParameters.mobileNumber.color}
                                        value={addAgentParameters.mobileNumber.value} />
                                </Grid.Item>
                                <Grid.Item
                                    size='col-12 md-6'>
                                    <TextField
                                        onChange={(value) => addAgentHandler('email', value)}
                                        label='ایمیل'
                                        color={addAgentParameters.email.color}
                                        value={addAgentParameters.email.value} />
                                </Grid.Item>
                                <Grid.Item
                                    className={`d-flex pb-0`}
                                    size='col-12 md-6'>
                                    <Button
                                        onClick={addAgent}
                                        className={`w-25`}
                                        variant='filled'
                                        color='primary'>
                                        تایید
                                    </Button>
                                    <Box
                                        className={`mx-sm`} />
                                    <Button
                                        onClick={() => closeModal('addMemberModal')}
                                        className={`w-25`}
                                        variant='outlined'
                                        color='primary'>
                                        انصراف
                                    </Button>
                                </Grid.Item>
                            </Grid.Wrapper>
                        </Grid>
                    </Box>
                </Modal.Wrapper>
            </Modal>
        </React.Fragment>
    );

}

export default Toolbar;